const RESIZE_OBSERVER_ERROR_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
];

const isResizeObserverLoopError = (message?: unknown) =>
  typeof message === 'string' && RESIZE_OBSERVER_ERROR_MESSAGES.some(item => message.includes(item));

const stopResizeObserverLoopError = (event: Event) => {
  const message =
    event instanceof ErrorEvent
      ? event.message
      : 'reason' in event
      ? (event as PromiseRejectionEvent).reason?.message || String((event as PromiseRejectionEvent).reason || '')
      : '';

  if (!isResizeObserverLoopError(message)) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', stopResizeObserverLoopError, true);
  window.addEventListener('unhandledrejection', stopResizeObserverLoopError, true);
}
